import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutContent"] */ "/opt/buildhome/repo/src/app/LayoutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleHydrator"] */ "/opt/buildhome/repo/src/app/LocaleHydrator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BtcRateProvider"] */ "/opt/buildhome/repo/src/lib/contexts/BtcRateContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocationProvider"] */ "/opt/buildhome/repo/src/lib/contexts/LocationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/buildhome/repo/src/lib/contexts/ThemeContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/globals.css");
